import { useEffect } from "react";

export function useKeyUp(callback, keyCodes) {
  const handler = ({ code }) => {
    if (keyCodes.includes(code)) {
      callback();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handler);
    return () => {
      window.removeEventListener("keyup", handler);
    };
  }, []);
}